import React, { type RefObject, useRef } from "react";
import FocusTrap from "focus-trap-react";
import { useCloseOnOutsideClick } from "../../../../../../../common-deprecated/hooks";
import FilterWrapper from "../../filters/FilterWrapper";
import * as Styles from "./styles/FilterPopupStyle";
import { useModelFilterLabel } from "../../../../utils/labels";
import { type ModelFilterDispatchType, useModelFilterSelector } from "../../../../redux/store";
import { showMoreFilters as showMoreFiltersAction } from "../../../../redux/actions/ModelFiltersActions";
import FilterPopupHeader from "../top-bar/FilterPopupHeader";
import type { ModelFilterId } from "../../../../utils/constants/filterConstants";
import useFilterPopup from "../../../../../../../shared-logic/features/filters/hooks/useFilterPopup";
import type { PosType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

type FilterPopupWrapperType = {
    filterId: ModelFilterId;
    originalPos: PosType;
    containerRef: RefObject<HTMLDivElement>;
    closeFilter: () => void;
};

const FilterPopup = (props: FilterPopupWrapperType): JSX.Element => {
    const { closeFilter, filterId, containerRef, originalPos } = props;
    const dispatch = useDispatch<ModelFilterDispatchType>();
    const filterRef = useRef<HTMLDivElement>(null);
    const showAllFiltersLabel = useModelFilterLabel("showAllFilters");
    const showMoreFilters = useModelFilterSelector((state) => state.modelFilters.showMoreFilters);

    useCloseOnOutsideClick(filterRef, closeFilter);

    const position = useFilterPopup(filterRef, containerRef, originalPos);

    return (
        <FocusTrap>
            <Styles.Wrapper left={position.x} top={position.y} ref={filterRef} id={filterId} role="dialog">
                <FilterPopupHeader filterId={filterId} onClose={closeFilter} />
                <Styles.Body>
                    <FilterWrapper filterId={filterId} darkVariant />
                </Styles.Body>
                {!showMoreFilters && (
                    <Styles.ShowFilters
                        onClick={() => {
                            closeFilter();
                            dispatch(showMoreFiltersAction(true));
                        }}
                    >
                        {showAllFiltersLabel}
                    </Styles.ShowFilters>
                )}
            </Styles.Wrapper>
        </FocusTrap>
    );
};

export default FilterPopup;
